import { useErrorHandler } from "../../../app-utils/graphql/useError.js";
import type { GetArrayElementType, GraphqlLazyResult } from "../../../types.d.ts";
import {
  type GetFeatureSuggestionsLazyQueryHookResult,
  type GetFeatureSuggestionsQuery,
  type GetFeatureSuggestionsQueryVariables,
  useGetFeatureSuggestionsLazyQuery,
} from "./search.gql.js";

export type FeatureSearchLazyResults = NonNullable<
  NonNullable<GetFeatureSuggestionsQuery["search"]>["globalSearch"]
>["categories"];
export type FeatureSearchLazyResult = GetArrayElementType<NonNullable<FeatureSearchLazyResults>>;
export type FeatureSearchCategory = GetArrayElementType<NonNullable<NonNullable<FeatureSearchLazyResult>["items"]>>;

export const useFeatureSearchLazy = (): GraphqlLazyResult<
  GetFeatureSuggestionsQueryVariables,
  GetFeatureSuggestionsLazyQueryHookResult,
  FeatureSearchLazyResults
> => {
  const [search, { data, loading, error }] = useGetFeatureSuggestionsLazyQuery();

  // if `throwError: true`, the redirect doesn't happen. In fact nothing happens.
  const handleError = useErrorHandler();

  const action = async (variables: GetFeatureSuggestionsQueryVariables) => {
    try {
      const result = await search({ variables });

      if (result.error) {
        throw result.error;
      }

      return result;
    } catch (error) {
      throw await handleError(error);
    }
  };

  return [action, { data: data?.search?.globalSearch?.categories, loading, error }];
};
